import React from 'react'
import companyImg from '../assets/images/compnay-office.webp'
import arrow from '../assets/images/right-arrow.webp'
import susblit from '../assets/images/susblit.webp'
import brainIco from '../assets/images/brain-ico.webp'
import map from '../assets/images/map-svg.webp'
import langData from '../locales/langData.json'
import { Link } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import SEO from '../components/SEO'
import '../assets/css/Company.css'
import BoardSection from '../components/BoardSection'

const Company = ({ language }) => {

    const company = langData[language].company;
    return (
        <>
            <SEO
                title="About CaptainX | Building Legacies with Sports Technology"
                titleAr="عن كابتن اكس | بناء إرث عريق بتكنولوجيا الرياضة"
                description="We are building legacies with AI-driven sports tech. Inspired by Saudi Vision 2030, we transform the global sports ecosystem through sustainable innovation."
                descriptionAr="نبني إرثًا عريقًا باستخدام تقنيات رياضية مدعومة بالذكاء الاصطناعي. مستوحين من رؤية السعودية 2030، نُحدث نقلة نوعية في المنظومة الرياضية العالمية من خلال الابتكار المستدام."
                path="/company"
                language={language}
            />


            <section className='company-sections'>
                <div className="container z-1">
                    <h2 className='block-view sec-title text-center' dangerouslySetInnerHTML={{ __html: company.title }}>
                    </h2>
                </div>
            </section>
            <section className='company-second' id='our-story'>
                <div className="container">
                    <div className="row d-none d-lg-flex">
                        <div className="col-md-5 col-img">
                            <LazyLoadImage src={companyImg} alt="company" className='img-fluid company-sec-img' />
                        </div>
                        <div className="col-md-1"></div>
                        {/* <div className="col-md-1"></div> */}
                        <div className="col-md-6 mob-our-story">
                            <h6 className="sec-top-titl">{company.secTopTitle}</h6>
                            <h2 className='sec-title'>{company.secTitle}</h2>
                            <p className='sec-p'>{company.secdesc}</p>
                        </div>
                    </div>
                    <div className="row d-flex d-lg-none">
                        <center>
                            <div className="col-12">
                                <LazyLoadImage src={companyImg} alt="company" className='img-fluid mb-3 comp-ipad-img' />
                            </div>
                        </center>
                        {/* <div className="col-md-1"></div> */}
                        {/* <div className="col-md-1"></div> */}
                        <div className="col-12 mob-our-story">
                            <h6 className="sec-top-titl">{company.secTopTitle}</h6>
                            <h2 className='sec-title'>{company.secTitle}</h2>
                            <p className='sec-p'>{company.secdesc}</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='card-t' id='vision'>
                <div className="container">
                    <h6 className='sec-top-titl p-2' >{company.cardTitle}</h6>

                    <div className="row feature-row">
                        {company.card.map((card, index) =>
                            <div className="col-md-6 col-lg-4 mb-4" key={index}>
                                <div className="company-boxs" >
                                    <div className="comp-box">
                                        <div className=" " >
                                            <div className="arrow-box"></div>
                                            <div className="news-cards desk-card">
                                                <h3>{card.num}</h3>
                                                <h2>{card.title}</h2>
                                                <p>{card.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom-box-arr">
                                        <LazyLoadImage src={arrow} alt="arrow" className='' />
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <section className='my-5 people-sec' id="people">
                {/* <div id="people">

                    <WebHorizontalScroll language={language} />
                </div> */}

                <BoardSection  language={language}/>
                {/* <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h6 className='sec-top-titl ' >{board.boardtoptitle}</h6>
                            <h2 className="sece-title">
                                {board.boardtitle}
                            </h2>
                            <p className="sec-p">
                                {board.boarddesc}
                            </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                    <div className="row">
                        {director.map((dir, index) =>

                            <div className="col-md-3">
                                <div className="img-slide-boxs" key={index}>
                                    <img src={dir.img} alt={dir.name} />
                                    <div className="member-detail">
                                        <h5 className="mem-name">{dir.name}</h5>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div> */}
            </section>

            <section className='sustable my-3' >
                <div className="container">
                    <div className="row justify-content-center align-items-center" id='sustainability'>
                        <div className="col-md-6">
                            <div className="sustable-cont">
                                <div className="">
                                    <h6 className='sec-top-titl'>{company.sustable.secToptitle}</h6>
                                    <h2>{company.sustable.title}</h2>
                                    <p className='sec-p sus-p'>{company.sustable.desc}
                                    </p>
                                </div>
                                <div className="row d-none">
                                    <div className="col">
                                        <LazyLoadImage src={brainIco} alt="brain" className='my-2' />
                                        <p className='sec-p sus-p'>
                                            {company.sustable.card1}
                                        </p>
                                    </div>
                                    <div className="col">
                                        <LazyLoadImage src={brainIco} alt="brain" className='my-2' />
                                        <p className='sec-p sus-p'>
                                            {company.sustable.card2}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-4 pt-3">
                            <LazyLoadImage src={susblit} alt="susblit" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>

            <section className='map-sec'>
                <div className="container">

                    <div className="cen-sec-con">

                        <center>
                            <h2 className='sec-title text-white pt-4'>
                                {company.maptitle}
                            </h2>
                        </center>
                    </div>
                    <div className="map-img">
                        <LazyLoadImage src={map} alt="map" className='img-fluid' />
                    </div>
                </div>

            </section>

            <section className='cta'>
                <div className="container">
                    <div className="cen-sec-con">

                        <center>
                            <h2 className='sec-title block-view' dangerouslySetInnerHTML={{ __html: company.ctatitle }}></h2>
                            <p className="sec-p block-view" dangerouslySetInnerHTML={{ __html: company.ctadesc }}></p>

                            <Link to='/contact' className='under-line'>
                                <button
                                    className={`explore-btn cta-btn my-4 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                        }`}
                                >{company.ctaButton}

                                    <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                                </button>
                            </Link>
                        </center>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Company